"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * tlDateInput
 */
ngModule.directive("tlDateInput", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-date tl-datepicker/>' + '   <i class="input-icon date-icon fa fa-calendar"></i> ' + '</div>',
    priority: 1000,
    // need to be higher than ngModel or any other transcluding directive
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-date-input-wrapper");
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-date-input.js
// module id = 2971
// module chunks = 13